import { IoIosDesktop } from "react-icons/io";
import BaseSection from "../components/BaseSection";
import CoursesSelect from "../components/Input/CoursesSelect";

export const COURSES_SECTION_INPUTS = {
  COURSES: "courses",
};

export default function CoursesSection({ inputs, errors, onChangeInput }) {
  return (
    <BaseSection title="Seleção de Cursos" Icon={<IoIosDesktop />}>
      <CoursesSelect
        multiple
        label="Curso"
        courses={inputs[COURSES_SECTION_INPUTS.COURSES]}
        errorMessage={errors[COURSES_SECTION_INPUTS.COURSES]}
        onChangeCourses={(courses) =>
          onChangeInput(COURSES_SECTION_INPUTS.COURSES, courses)
        }
      />
    </BaseSection>
  );
}
